
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bug-report",
      function () {
        return require("private-next-pages/bug-report.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bug-report"])
      });
    }
  